import conn from "./connections";

export const requestPasswordReset = email =>
  conn.postJSON(`${conn.base_url}/requestPasswordReset`, { email });

export const setNewPassword = (password, token) =>
  conn.postJSON(`${conn.base_url}/resetPassword`, { password, token });
